import { intrinsicClassName } from '../../../utils/reactView';
import styles from './Row.module.css';

export const Row = intrinsicClassName('div', styles.row);
